import { useSelector } from "react-redux";
import { fetchPage } from "../../actions/page";
import PageNotFound from "../_error";
import { Title, Section } from "@vshp/ui-components";
import programDisciplinesBg from "../../../public/images/disciplines.jpg";

import PageText from "../../components/page/PageText";
import PageList from "../../components/page/PageList";
import PageCode from "../../components/page/PageCode";
import PageImages from "../../components/page/PageImages";
import PageVideo from "../../components/page/PageVideo";
import PageDocuments from "../../components/page/PageDocuments";
import PageContentButton from "../../components/page/PageContentButton";

import { wrapper } from "../../store";
import Image from "next/image";
import Head from "next/head";

function PostPage() {
  const { page, pageAreLoading } = useSelector((state) => state.page);

  if (pageAreLoading && page.length <= 0) {
    return <PageNotFound />;
  }
  return (
    <>
      <Head>
        <title>{page.title}</title>
        <meta property="og:title" content={page.title} key="title" />
      </Head>
      <div className="page__header">
        <Image className="page__header-cover" src={programDisciplinesBg} alt={page.title} priority={false} />
        <div className="page__header-body page__header-body_center page__header-body_theme">
          <Title decor={false} className="page__header-title">
            {page.title}
          </Title>
        </div>
      </div>

      <div className="page__blocks">
        <Section>
          <div className="page__block-body_small">
            {page.contents.map((item, key) => {
              let content = null;
              switch (item.kind) {
                case "text":
                  content = <PageText text={item.content} title={item.title} />;
                  break;
                case "list":
                  content = <PageList list={item.contents} title={item.title} />;
                  break;
                case "image":
                  content = <PageImages images={item.contents} title={item.title} />;
                  break;
                case "video":
                  content = <PageVideo video={item.content} title={item.title} />;
                  break;
                case "code":
                  content = <PageCode code={item.content} title={item.title} />;
                  break;
                case "button":
                  content = <PageContentButton button={item.data} text={item.content} title={item.title} />;
                  break;
                case "documents":
                  content = <PageDocuments files={item.contents} title={item.title} />;
                  break;
                default:
                  break;
              }
              return (
                <div key={key} className={`page__block ${key === page.contents.length - 1 ? "" : "page__block_border"}`}>
                  <div className="wysiwyg">{content}</div>
                </div>
              );
            })}
          </div>
        </Section>
      </div>
    </>
  );
}

export const getServerSideProps = wrapper.getServerSideProps((store) => async ({ resolvedUrl }) => {
  await store.dispatch(fetchPage(resolvedUrl));
});

export default PostPage;
